/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/unauthOneTimeCyberAgentScanEmailVerificationMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a UnauthOneTimeCyberAgentScanEmailVerification. */
export class UnauthOneTimeCyberAgentScanEmailVerification {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a UnauthOneTimeCyberAgentScanEmailVerification.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Generates a security code and sends it to the email address.
   * @summary Generates a security code that is sent to the email address.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  generateCode(options?: Models.UnauthOneTimeCyberAgentScanEmailVerificationGenerateCodeOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  generateCode(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  generateCode(options: Models.UnauthOneTimeCyberAgentScanEmailVerificationGenerateCodeOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  generateCode(options?: Models.UnauthOneTimeCyberAgentScanEmailVerificationGenerateCodeOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      generateCodeOperationSpec,
      callback);
  }

  /**
   * Verifies the security code of the email address.
   * @summary Verifies the security code for the email address.
   * @param [options] The optional parameters
   * @returns Promise<Models.UnauthOneTimeCyberAgentScanEmailVerificationVerifyCodeResponse>
   */
  verifyCode(options?: Models.UnauthOneTimeCyberAgentScanEmailVerificationVerifyCodeOptionalParams): Promise<Models.UnauthOneTimeCyberAgentScanEmailVerificationVerifyCodeResponse>;
  /**
   * @param callback The callback
   */
  verifyCode(callback: coreHttp.ServiceCallback<Models.UnauthOneTimeCyberAgentScanVerifyCodeResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  verifyCode(options: Models.UnauthOneTimeCyberAgentScanEmailVerificationVerifyCodeOptionalParams, callback: coreHttp.ServiceCallback<Models.UnauthOneTimeCyberAgentScanVerifyCodeResponse>): void;
  verifyCode(options?: Models.UnauthOneTimeCyberAgentScanEmailVerificationVerifyCodeOptionalParams | coreHttp.ServiceCallback<Models.UnauthOneTimeCyberAgentScanVerifyCodeResponse>, callback?: coreHttp.ServiceCallback<Models.UnauthOneTimeCyberAgentScanVerifyCodeResponse>): Promise<Models.UnauthOneTimeCyberAgentScanEmailVerificationVerifyCodeResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      verifyCodeOperationSpec,
      callback) as Promise<Models.UnauthOneTimeCyberAgentScanEmailVerificationVerifyCodeResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const generateCodeOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/UnauthOneTimeCyberAgentScan/email/code",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.EmailVerificationGenerateCodeRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const verifyCodeOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/UnauthOneTimeCyberAgentScan/email/verify",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.EmailVerificationCodeRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.UnauthOneTimeCyberAgentScanVerifyCodeResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
